import { render, staticRenderFns } from "./ConformitySettings.vue?vue&type=template&id=f2a996a4&scoped=true&"
import script from "./ConformitySettings.vue?vue&type=script&lang=js&"
export * from "./ConformitySettings.vue?vue&type=script&lang=js&"
import style0 from "./ConformitySettings.vue?vue&type=style&index=0&id=f2a996a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a996a4",
  null
  
)

export default component.exports